import {
  svgPathStyle,
  svgStyle
} from 'components/display/ValidationIconStyles';
import React from 'react';

function ErrorCross({ overrideSvgStyle }) {
  return (
    <svg
      css={overrideSvgStyle || svgStyle}
      preserveAspectRatio='xMidYMin'
      title='Error'
      viewBox='0 0 52 52'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path css={svgPathStyle} fill='none' d='M16 16 36 36' stroke='#c9302c' />
      <path
        css={[svgPathStyle, { animationDelay: '0.25s' }]}
        d='M36 16 16 36'
        fill='none'
        stroke='#c9302c'
      />
    </svg>
  );
}

export default ErrorCross;
